import { useEffect, useState } from "react";
import { type StyleProp, View, type ViewStyle } from "react-native";
import Box from "../Box";
import CustomDateInput from "./CustomDateInput";
import CustomDatePickerModal from "./CustomDatePickerModal";
import DatePickerWrapper from "./DatePickerWrapper";

interface DatePickerProps {
	isClearVisible?: boolean;
	mode?: "single" | "range";
	onChange?: (params: {
		date?: Date;
		startDate?: Date;
		endDate?: Date;
	}) => void;
	onClose?: () => void;
	onOk?: (value: Date | { startTime: Date; endTime: Date } | null) => void;
	onClear?: () => void;
	startDate?: Date;
	endDate?: Date;
	date?: Date;
	validRange?: {
		startDate?: Date;
		endDate?: Date;
	};
	inputLabel?: string;
	pickerType: "calendar" | "input" | "wrappedInput";
	style?: StyleProp<ViewStyle>;
}

export const DatePicker = ({
	isClearVisible = true,
	mode = "single",
	onClose,
	onOk,
	onClear,
	startDate,
	endDate,
	date,
	validRange,
	pickerType = "calendar",
	style,
	inputLabel,
}: DatePickerProps) => {
	const [selectedDate, setSelectedDate] = useState<Date | undefined>(date);
	const [dateRange, setDateRange] = useState({
		startDate,
		endDate,
	});

	useEffect(() => {
		setSelectedDate(date);
	}, [date]);

	useEffect(() => {
		setDateRange({ startDate, endDate });
	}, [startDate, endDate]);

	if (pickerType === "input") {
		return (
			<Box>
				<CustomDateInput
					value={selectedDate?.toLocaleString()}
					onOk={onOk}
					label={inputLabel}
					validRange={validRange}
					showClear={isClearVisible}
				/>
			</Box>
		);
	}
	if (pickerType === "wrappedInput") {
		return (
			<View>
				<DatePickerWrapper
					isClearVisible={isClearVisible}
					mode={mode}
					validRange={validRange}
					onOk={onOk}
					onClose={onClose}
					onClear={onClear}
					style={style}
					inputLabel={inputLabel}
				/>
			</View>
		);
	}
	if (pickerType === "calendar") {
		return (
			<Box style={style}>
				<CustomDatePickerModal
					mode={mode}
					date={selectedDate}
					startDate={dateRange.startDate}
					endDate={dateRange.endDate}
					label={inputLabel}
					onOk={onOk}
					onClose={onClose}
					onClear={onClear}
					isClearVisible={isClearVisible}
					validRange={validRange}
				/>
			</Box>
		);
	}
};

export default DatePicker;
